module.exports = `${require.publicPath}icon02.85beacce.png`;